<template>
  <div class="inline-flex no-notifications-container">
    <div>
      <img class="big-bell" src="/images/notifications/notification-bell-read.svg"/>
    </div>
    <div class="no-notifications-text-container">
      <h1 v-if="!assignedOnly">No {{flaggedText}} notifications found for {{ showingNotificationsForName }}.</h1>
      <h1 v-else>No {{flaggedText}} notifications found for assigned orders.</h1>
      <div>Notifications about orders, review tasks and invoices will appear here.</div>
      <div>Try adjusting the filters if you think you should be seeing notifications.</div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "no-notifications-panel",
  computed: {
    ...mapState('PortalNotificationStore', ['assignedOnly', 'flaggedOnly']),
    ...mapGetters(
        'PortalNotificationStore', [
          "showingNotificationsForName"
        ]
    ),
    flaggedText(){
      return this.flaggedOnly ? ' flagged ' : '';
    }
  }
};
</script>
